import styled from 'styled-components';

const Container = styled.div`
  padding: 3px;
`;

export const Styled = {
  Container,
};
